import pluralize from "pluralize";
import {IconType} from "react-icons";
import {AiOutlinePhone} from "react-icons/ai";
import {FaWhatsapp} from "react-icons/fa";
import {FiMail, FiMessageSquare} from "react-icons/fi";
import {HiOutlineSwitchHorizontal} from "react-icons/hi";

import {Chip} from "@/components/chip/Chip.tsx";
import {Icon} from "@/components/icon/Icon.tsx";
import {ContactGroup} from "@/lib/types/contacts.ts";

import styles from "./ContactChannelBadges.module.scss";

interface ChannelBadge {
  icon: IconType;
  count: number;
  label: string;
}

export interface ContactChannelBadgesProps {
  contact: ContactGroup;
}

export const ContactChannelBadges = ({contact}: ContactChannelBadgesProps) => {
  const badges: ChannelBadge[] = [
    {icon: FiMail, count: contact.email_list.length, label: "Email"},
    {
      icon: HiOutlineSwitchHorizontal,
      count: contact.integrations.length,
      label: "Integration",
    },
    {icon: FiMessageSquare, count: contact.sms_list.length, label: "SMS"},
    {
      icon: AiOutlinePhone,
      count: contact.phonecall_list.length,
      label: "Phone Number",
    },
    {icon: FaWhatsapp, count: contact.whatsapp_list.length, label: "WhatsApp Recipient"},
  ].filter((badge) => badge.count > 0);

  if (badges.length === 0) {
    return null;
  }

  return (
    <div className={styles.badges}>
      {badges.map(({icon, count, label}) => (
        <Chip key={label} variant="tag" size="smallLight">
          <Icon icon={icon} size="tiny" />
          {pluralize(label, count, true)}
        </Chip>
      ))}
    </div>
  );
};
